import * as React from 'react'
import {  connect } from 'react-redux'
import { navigateToCategory } from '../../actions/answers'
import { currentParamsSelector } from '../../selectors/navigation'
import { RootState } from '../../types/rootstate'
import { strings } from '../../lib/localization'

interface StateProps {
  params: any
}

interface DispatchProps {
  navigateToCategory: (userId: number, answersId: number, categoryId: number, categoryName: string) => void
}

interface OwnProps {
  field: any
}

type MainProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    params: currentParamsSelector(state)
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    navigateToCategory: (userId, answersId, categoryId, categoryName) =>
      dispatch(navigateToCategory(userId, answersId, categoryId, categoryName))
  }
}

interface MainState {
}


class CategoryComponent extends React.Component<MainProps, MainState> {

  /*
    Vid klick så skickades detta anrop:
    https://apiv2.imbox.io/api/faq/865/categories/1160/articles?callback=J50Npi.success

  */

  handleCategoryClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.navigateToCategory(
      this.props.params.userId,
      this.props.params.formId,
      this.props.field.categoryId,
      this.props.field.label
    )
  }

  handleCategoryKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.props.navigateToCategory(
        this.props.params.userId,
        this.props.params.formId,
        this.props.field.categoryId,
        this.props.field.label
      )
    }
  }

  render () {
    const ariaLabel = this.props.field.label
      ? this.props.field.label
      : strings.formatString(strings.a11yFAQCategory, { categoryId: this.props.field.categoryId })

    return (
      <div
        className={this.props.field.className !== '' ? this.props.field.className : 'col-xs-6'}
        id={this.props.field.categoryId}
      >
        <div
          className='answers-category-item'
          onClick={this.handleCategoryClick}
          role='link'
          tabIndex={0}
          onKeyDown={this.handleCategoryKeyDown}
          aria-label={ariaLabel}>

          {this.props.field.icon &&
          <div
            className='answers-category-item-icon-wrapper'
          >
            <img
              className='answers-category-item-icon'
              src={this.props.field.icon}
              style={{ height: this.props.field.iconHeight, width: this.props.field.iconHeight }}
              alt=''
            />
          </div>
          }

          {this.props.field.label &&
          <span
            className='answers-category-item-label'
          >
            {this.props.field.label}
          </span>
          }
        </div>

      </div>
    )
  }
}

const Category = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(CategoryComponent)


export {
  Category
}
